import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { catchError, filter, map, Observable, of, switchMap, take } from 'rxjs';
import { ICustomerService } from '../../services/customer/customer.service.interface';
import { SecurityService } from '../security.service';

@Injectable()
export class ContextGuardService {
  constructor(
    private customerService: ICustomerService,
    private securityService: SecurityService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<true | UrlTree> {
    const customerAxCode = route.params['customerAxCode']?.trim().toUpperCase();
    if (!customerAxCode) {
      return of(this.router.parseUrl('/'));
    }

    return this.securityService.$authorizationStartupInProgress.pipe(
      filter(startup => !startup),
      take(1),
      switchMap(() => {
        if (!this.securityService.hasCustomerAccess(customerAxCode)) {
          return of(this.router.parseUrl('/'));
        }

        const currentAccount = this.securityService.getCurrentAccountObject();
        if (currentAccount?.AXCode?.toUpperCase() === customerAxCode) {
          return of(true as const);
        }

        return this.customerService.getCustomerByCode(customerAxCode).pipe(
          map(customer => {
            if (!customer) {
              return this.router.parseUrl('/');
            }

            this.securityService.setCurrentAccount(customer);
            return true as const;
          }),
          catchError(error => {
            console.error(error);
            return of(this.router.parseUrl('/'));
          })
        );
      })
    );
  }
}
